// Meta Pixel utility functions
// Pixel ID: 1307491777790531

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

const PIXEL_ID = '1307491777790531'
let isInitialized = false

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  if (isInitialized) return

  console.log('[Meta Pixel] Starting initialization...')

  // Create fbq function before script loads
  if (!window.fbq) {
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue.push(args)
      }
    }
    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []
    window.fbq = fbq
    window._fbq = fbq
  }

  // Load the Facebook Pixel script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'

  script.onload = () => {
    console.log('[Meta Pixel] Script loaded successfully')
  }

  script.onerror = () => {
    console.error('[Meta Pixel] Failed to load script')
  }

  // Append to head (more reliable than insertBefore)
  document.head.appendChild(script)

  // Initialize with Pixel ID
  window.fbq('init', PIXEL_ID)
  console.log('[Meta Pixel] Pixel initialized with ID:', PIXEL_ID)

  // Track PageView
  window.fbq('track', 'PageView')
  console.log('[Meta Pixel] PageView event queued')

  isInitialized = true
}

export function trackPageView(): void {
  if (typeof window === 'undefined' || !window.fbq) {
    console.warn('[Meta Pixel] Cannot track PageView - fbq not available')
    return
  }

  window.fbq('track', 'PageView')
  console.log('[Meta Pixel] PageView tracked')
}

export function trackAddToCart(params?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}): void {
  if (typeof window === 'undefined') {
    console.warn('[Meta Pixel] Cannot track - window undefined')
    return
  }

  if (!window.fbq) {
    console.warn('[Meta Pixel] Cannot track AddToCart - fbq not available')
    return
  }

  const eventParams = params || {
    content_name: 'Anti-Roomies: Reset de 14 Días',
    content_type: 'product',
    value: 6.39,
    currency: 'USD',
  }

  window.fbq('track', 'AddToCart', eventParams)
  console.log('[Meta Pixel] AddToCart tracked:', eventParams)
}

// Debug function to check pixel status
export function debugPixel(): void {
  console.log('[Meta Pixel Debug]', {
    isInitialized,
    fbqExists: typeof window !== 'undefined' && !!window.fbq,
    pixelId: PIXEL_ID,
  })
}
